import { useCallback } from 'react';

import { useSwitchToNextEpisodeWithAnalytics } from '../../feature-player/hooks/skin/use-switch-to-next-episode-with-analytics';
import { useIsAutoSkipEnabled } from '../../feature-player/ui/skin/next-episode-skip-button-group/hooks/use-is-auto-skip-enabled';

import { useNextEpisode } from './use-next-episode';

interface UseOnFinishEpisodeProps {
    contentId: string;
}

export const useOnFinishEpisode = ({ contentId }: UseOnFinishEpisodeProps) => {
    const hasNextEpisode = !!useNextEpisode(contentId);
    const { getIsAutoSkipEnabled, autoSkipHappened } = useIsAutoSkipEnabled({
        contentId,
    });

    const skip = useSwitchToNextEpisodeWithAnalytics(contentId);

    const onFinish = useCallback(() => {
        if (hasNextEpisode && getIsAutoSkipEnabled()) {
            autoSkipHappened();
            skip('NEXT_EPISODE_AFTER_CREDITS');
        }
    }, [autoSkipHappened, getIsAutoSkipEnabled, hasNextEpisode, skip]);

    return { onFinish };
};
